<template>
  <v-footer
    min-height="200px"
    color="grey lighten-3"
    light
    class="mt-16 pt-8"
  >
    <v-row>
      <v-col cols="12">
        <small>
          <contact-info></contact-info>
        </small>
        <v-divider class="my-4"></v-divider>
        <small>
          &copy; 2011-{{ year }} {{ name.zh }}<br />
          {{ name.en }}. All Rights Reserved
        </small>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  components: {
    'contact-info': () => import('../contact/info')
  },
  computed: {
    name() {
      return this.$store.state.name;
    },
    year() {
      return new Date().getFullYear();
    },
    menu() {
      return this.$store.state.menu.slice(1,4);
    },
  }
}
</script>